module.exports = __webpack_public_path__ + "static/flatart-slider-news-mobile-44d4ad36f828c1ff45d8c3d12eb5f5f8.webp";